import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Attributes/CreateDialog';
import { Attribute } from '@/models/Attribute';
import { AttributeOption } from '@/models/AttributeOption';

@Component<Attributes>({
  components: {
    CreateDialog,
  },
})
export default class Attributes extends Vue {

  protected selectedAttribute: Attribute | null = null;
  protected isCreatingAttribute: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Attribute().include('options'),
      name: {
        singular: 'Attribute',
        plural: 'Attributes',
      },
      sort: {
        key: 'title',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'title',
          sortable: {
            key: 'title',
            order: 'ASC',
          },
          width: '200px',
        },
        {
          text: 'Type',
          value: 'type',
          width: '200px',
        },
        {
          text: 'Options',
          value: 'options',
          transform: (attributeOptions: AttributeOption[]) => {
            if(!attributeOptions || !attributeOptions.length) {
              return '-';
            }

            let string = '';
            attributeOptions.forEach((attributeOption: AttributeOption) => {
              string += `<span class="sub-color-pill">${attributeOption.title}</span>`
            });

            return string;
          }
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, attribute: Attribute) => {
            this.selectedAttribute = attribute;
            this.isCreatingAttribute = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, attribute: Attribute) => {
            this.selectedAttribute = attribute;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingAttribute = true;
      }
    };
  }

  protected get attributesDatatable(): DataTable|null {
    const dataTable = this.$refs.attributesDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedAttribute as Attribute).title || 'Confirm deletion',
      text: 'Are you sure you wish to delete this attribute?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedAttribute) {
              return;
            }

            this.selectedAttribute
              .delete()
              .then((response: any) => {
                if (response) {
                  this.attributesDatatable ? this.attributesDatatable.refresh(true) : null;
                  this.selectedAttribute = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedAttribute = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingAttribute')
  protected isCreatingAttributeChanged() {
    if(!this.isCreatingAttribute) {
      this.selectedAttribute = null;
    }
  }
}
